import { storeState } from '@/js/storage'
import { GOALS } from '@/js/constants'
import { getQueryForDeliveryHistoryByProjectId } from '@adtelligence/vue-integration-library'
import { cxConfiguration } from '@/js/config'
import ccLogoBlue from '@/assets/svgs/cc-logo-blue.svg'

/**
 * Returns the goal id for the current step
 * @returns {array} GoalIds
 */
export const getGoalIdsForTracking = function () {
  const goalIds = []
  switch (window.location.pathname.split('/').pop()) {
    case 'ProductSelection':
      goalIds.push(GOALS.load_product_selection)
      break
    case 'PersonalData':
      goalIds.push(GOALS.load_personal_data)
      break
    case 'Address':
      goalIds.push(GOALS.load_address)
      break
    case 'FinancialInformation':
      goalIds.push(GOALS.load_financial_information)
      break
    case 'AdditionalServices':
      goalIds.push(GOALS.load_additional_services)
      break
    case 'BeneficialOwner':
      goalIds.push(GOALS.load_beneficial_owner)
      break
    case 'InformationRecap':
      goalIds.push(GOALS.load_information_recap)
      break
    case 'Confirm':
      goalIds.push(GOALS.load_confirm)
      break
    case 'IDUpload':
      goalIds.push(GOALS.load_id_upload)
      break
    case 'ContractView':
      goalIds.push(GOALS.load_contract_view)
      break
    case 'DigitalSignature':
      goalIds.push(GOALS.load_digital_signature)
      break
    case 'NoCardPossible':
      goalIds.push(GOALS.load_no_card_possible)
      break
    case 'GenericError':
      goalIds.push(GOALS.load_generic_error)
      break
    case 'ChargeConfirmation':
      goalIds.push(GOALS.load_charge_confirmation)
      goalIds.push(GOALS.load_charge_success_overall2)
      break
    case 'SuccessEmailRequest':
      goalIds.push(GOALS.load_success_email_request)
      goalIds.push(GOALS.load_success_email_print_overall)
      break
    case 'SuccessPrintService':
      goalIds.push(GOALS.load_success_print_service)
      goalIds.push(GOALS.load_success_email_print_overall)
      break
    case 'SuccessPrintServiceNoDoc':
      goalIds.push(GOALS.load_success_print_service_no_doc)
      goalIds.push(GOALS.load_success_email_print_overall)
      break
    case 'SuccessPrintAtHome':
      goalIds.push(GOALS.load_success_print_at_home)
      goalIds.push(GOALS.load_success_email_print_overall)
      break
    case 'SuccessDigitalSignature':
      goalIds.push(GOALS.load_success_digital_signature)
      goalIds.push(GOALS.load_success_digital_signature_overall)
      goalIds.push(GOALS.load_charge_success_overall2)
      break
    case 'SuccessDigitalSignatureCharge':
      goalIds.push(GOALS.load_success_digital_signature_charge)
      goalIds.push(GOALS.load_success_digital_signature_overall)
      goalIds.push(GOALS.load_charge_success_overall2)
      break
    case 'SuccessDigitalSignatureNoDoc':
      goalIds.push(GOALS.load_success_digital_signature_no_doc)
      goalIds.push(GOALS.load_success_digital_signature_overall)
      break
    case 'SuccessDigitalSignatureChargeNoDoc':
      goalIds.push(GOALS.load_success_digital_signature_charge_no_doc)
      goalIds.push(GOALS.load_success_digital_signature_overall)
      goalIds.push(GOALS.load_charge_success_overall2)
      break
    default:
  }
  return goalIds
}

/**
 * Initializies tracking for variations
 */
export const initVariationTracking = function (trackingInstance) {
  // Interval to detect URL changes in Funnel and then track
  let lastGoalIds
  setInterval(function () {
    const goalIds = getGoalIdsForTracking()
    if (!compareArrays(goalIds, lastGoalIds)) {
      goalIds.forEach(goalId => {
        trackingInstance.track(goalId)
      })
      lastGoalIds = goalIds
    }
  }, 1000)

  const trackSelector = function (selector, goalIds) {
    document.body.addEventListener('click', e => {
      if (
        [...document.querySelectorAll(selector)].find(node => node.isEqualNode(e.target) || node.contains(e.target))
      ) {
        goalIds.forEach(goalId => {
          trackingInstance.track(goalId)
        })
      }
    })
  }

  trackSelector('.cta > .cc-btn', [GOALS.cta_overall])
}

const compareArrays = (a, b) => {
  return JSON.stringify(a) === JSON.stringify(b)
}

export const pushToAdobeDataLayer = function (variationId, projectId) {
  //initializate the DL if not exist
  window.adobeDataLayer = window.adobeDataLayer || []

  if (projectId === 3) {
    variationId = Number(getQueryForDeliveryHistoryByProjectId(cxConfiguration.analyticsSiteId, 4)?.get('contentGroup'))
  }

  let variationName = ''
  switch (variationId) {
    case 2:
      variationName = 'benchmark'
      break
    case 102:
      variationName = 'shoppingqueen'
      break
    case 103:
      variationName = 'pizzahotel'
      break
    case 104:
      variationName = 'shoppingqueen0823'
      break
    case 105:
      variationName = 'swiss0823'
      break
    default:
  }

  //create the event object
  const adtelligenceObj = {
    event: 'adtelligence',
    data: {
      variation: {
        'adtelligence-variation': variationName
      }
    }
  }

  //push the event into the DL
  if (variationName) {
    window.adobeDataLayer.push(adtelligenceObj)
  }
}

/**
 * Gets Language from url
 * @returns {string} Language
 */
export const getLanguage = function () {
  return window.location.pathname.split('/')[1]
}

/**
 * Store Translation for given Language in Store
 * @param {string} lang Language to get Translation for
 */
export const storeTranslations = function (lang) {
  import(`./i18n/${lang}`).then(translations => {
    storeState.text = translations.text
  })
}

/**
 * Get Text for Field
 * @param {string} field Field you want the text for
 * @returns {string} Text
 */
export const getText = function (field) {
  let text = storeState.text
  const split = field.split('.')
  split.forEach(elem => {
    text = text[elem]
  })
  return text
}
/**
 * Replace Header Logo
 */
export const replaceHeaderLogo = function () {
  document.querySelector('body > div.v2 > header > div > div > div.logo > a > img').src = ccLogoBlue
}

export const initBenchmarkSticky = function () {
  const check = function () {
    const sticky = document.querySelector('#sticky')
    const firstCta = document.querySelector('.adt-cta-primary')
    const firstCtaRect = firstCta ? firstCta.getBoundingClientRect() : false
    const isScrolledPastFirstCta = firstCtaRect.top + firstCtaRect.height < 0
    sticky.classList[sticky && isScrolledPastFirstCta ? 'add' : 'remove']('show')
  }
  window.addEventListener('resize', check)
  window.addEventListener('scroll', check)
  check()
}
